import { AnyAction, isType } from 'typescript-fsa';
import { UserSong } from '../../../services/playlist';
import { myPlaylistSet, myPlaylistSetVisibility } from './actions';

export interface MyPlaylistState {
    userSongs: UserSong[];
    playlistPublic: boolean;
}

const initialMyPlaylistState: MyPlaylistState = {
    userSongs: [],
    playlistPublic: false
};

export function myPlaylistReducer(state: MyPlaylistState = initialMyPlaylistState, action: AnyAction): MyPlaylistState {
    if (isType(action, myPlaylistSet)) {
        return { ...state, userSongs: action.payload };
    } else if (isType(action, myPlaylistSetVisibility)) {
        return { ...state, playlistPublic: action.payload };
    }

    return state;
}
